import { DotSeparatedList, Text } from "@src/appV2/redesign/system/ui-components";
import { type ComponentProps, type ReactNode } from "react";

export const textDefaultProps: ComponentProps<typeof Text> = {
  semibold: true,
  color: (theme) => theme.palette.text.secondary,
  variant: "body2",
};

interface DotSeparatedTextProps {
  children: ReactNode | ReactNode[];
}

export function DotSeparatedText(props: DotSeparatedTextProps) {
  const { children } = props;

  return (
    <Text {...textDefaultProps} inline>
      <DotSeparatedList>{children}</DotSeparatedList>
    </Text>
  );
}
